export default {
      id: "summary-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#summary",
      toString: function () {
        return this.url;
      }
    }